
let vm = null //vue对象
let msgMapList = new Map() //msg列表
let isListPage = true //是否在列表页
let batchRequestTimer = null //详情批量请求定时器


class timerObj {
  // oldMsg = {}//上一条信息
  msg = {}//最新信息
  timer = null//延时器
  isHasSubmitMsg = false//是否有SUBMIT_ANSWER事件
  hasNewMsg = false //批量调用，是否有新消息
  setMsg(message){
    this.msg = message;
    this.hasNewMsg = true
    if(this.msg.event == 'SUBMIT_ANSWER'){
      this.isHasSubmitMsg = true
    }
    if(isListPage){
      if(!this.timer){
        this.timer = setTimeout(()=>{
          console.log(this.msg,"msgMapList 3s后获取信息 1111")
          if(this.msg.user_id){
            // this.oldMsg = this.msg
            this.hasNewMsg = false
            vm.checkUserInfoFun(this.msg,this.isHasSubmitMsg)
            clearTimeout(this.timer)
            this.isHasSubmitMsg = false
            this.timer = null
          }
        },3000)
      }
    }
  }
  //更新信息
  addMessage(message){
    console.log('111111 addMessage',message)
    let messages = {
      module_sname:this.msg.module_name || '',
      tag_sname:message.knowledge_info?message.knowledge_info.tag_name:'',
      correct_notify:message.correct_notify
    }
    this.hasNewMsg = false
    const msg = Object.assign(this.msg, messages)
    vm.addMessage(msg)
  }
  //销毁延时器
  destroyed(){
    this.timer && clearTimeout(this.timer)
    this.timer = null
  }
  //立即请求
  getDataNow(){
    if(this.hasNewMsg){
      this.hasNewMsg = false
      vm.checkUserInfoFun(this.msg,this.isHasSubmitMsg)
      this.isHasSubmitMsg = false
    }
  }
  initTimeout(){
    this.setMsg(this.msg)
  }
}
//控制器
class getMsgContorl {
  init(vueObj, single = true) {
    vm = vueObj
    if(vm.$route.path.includes('detail')){
      isListPage = false
    }

  }
  //列表页有新消息3s后各自刷新一次
  addMsg(msg){
    console.log('addMsg 111111')
    if(msgMapList.has(msg.user_id)){
      console.log(msg,"msgMapList 中有此id 1111")
      msgMapList.get(msg.user_id).setMsg(msg)
    } else{
      console.log(msg,"msgMapList 没有此id 1111")
      msgMapList.set(msg.user_id,new timerObj())
      msgMapList.get(msg.user_id).setMsg(msg)
    }
    if(!isListPage){
      this.batchGetData()
    }
  }
  //从详情页进列表页立即刷新一次,后续启用3s各自请求,销毁批量定时器
  detailToList(){
    isListPage = true
    console.log('detailToList 111111',[...msgMapList.values()])
    if(batchRequestTimer){
      clearInterval(batchRequestTimer)
      batchRequestTimer = null;
    }
    for(let item of msgMapList.values()){
      item.destroyed()
      item.getDataNow()
    }
  }
  //从列表页进入详情页，销毁3秒延时器，启动全局批量获取数据3秒定时器
  listToDetail(options, single = true) {
    isListPage = false
    console.log('listToDetail 111111',[...msgMapList.values()])
    for(let item of msgMapList.values()){
      item.destroyed()
    }
    this.batchGetData()
  }
  //详情页批量加载知识点名和主观题批改字段
  batchGetData() {
    if(!batchRequestTimer){
      batchRequestTimer = setInterval(()=>{
        //当前在看的学生请求数据
        if(vm.currentViewStudent['user_id'] && msgMapList.has(vm.currentViewStudent['user_id'])){
          console.log('当前在看的学生请求数据 1111',99996)
          msgMapList.get(vm.currentViewStudent['user_id']).getDataNow()
        }
        //其余的批量请求
        console.log('batchGetData批量请求 111111')
        let params = []
        for(let item of msgMapList.values()){
          const msg = item.msg
          if(item.hasNewMsg && vm.currentViewStudent['user_id'] != msg.user_id){
            const data = {
              school_id: msg.school_id,
              user_id: msg.user_id,
              course_id: msg.course_id,
              topic_id: msg.topic_id,
              lesson_id: msg.lesson_id,
              knowledge_code: msg.tag_code,
              stage: msg.module_type,
              flow_id: msg.flow_id,
              subject_id: msg.subject_id,
              jupiter_stage: msg.stage,
              learning_version: msg.learning_version || '',
              question_bank_version: msg.question_bank_version || '',
              question_vno: msg.question_vno || 0,
              module_id: msg.module_type || 0,
              with_extend: 0
            }
            params.push(data)
          }
        }
        if(params.length){
          vm.batchGetData({
            subject_id:sessionStorage.getItem('subject_id'),
            params,
          }).then(function(datas){
            let ids = Object.keys(datas) || []
            if(ids.length){
              ids.forEach(item => {
                console.log(item,11111198)
                msgMapList.get(item).addMessage(datas[item])
              });
            }
          })
        }
      },3000)
    }
    console.log('batchGetData 111111')
  }
  
}
export default new getMsgContorl()


// WEBPACK FOOTER //
// ./src/utils/getMsgContorl.js